import script from "./QRTemplateThree.vue?vue&type=script&lang=ts&setup=true"
export * from "./QRTemplateThree.vue?vue&type=script&lang=ts&setup=true"

import "./QRTemplateThree.vue?vue&type=style&index=0&id=5117c006&lang=css"
/* custom blocks */
import block0 from "./QRTemplateThree.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__